<template>
  <CommonLayout header="traderHeader" footer="traderFooter">
    <div class="container">
      <div class="main-color text-light row mt-3">
        <div class="col p-2">
          制作案件一覧
        </div>
      </div>
      <div id="search-box" class="row mt-3 base-color">
        <div class="accordion col p-0" role="tablist">
          <BCard no-body>
            <BCardHeader header-tag="header" class="p-0" role="tab">
              <BButton block v-b-toggle.accordion-1 class="light-blue text-start">検索条件</BButton>
            </BCardHeader>
            <BCollapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <BCardBody>
                <form method="post" action="#" class="form-horizontal">
                  <div class="form-group">
                    <label for="code" class="control-label col-sm-12">ステータス</label>
                    <div class="col-sm-12">
                      <template v-for="(searchStatusLabel, index) in searchStatusLabels" :key="index">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="inlineRadioOptions" :id="'inlineRadio' + index" value="option1">
                          <label class="form-check-label" :for="'inlineRadio' + index">{{searchStatusLabel}}</label>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4">
                      <label for="name" class="control-label col-sm-12">案件No.</label>
                      <div class="col-sm-12">
                        <input type="text" name="name" id="name" class="form-control input-sm"/>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <label for="name" class="control-label col-sm-12">施工名</label>
                      <div class="col-sm-12">
                        <input type="text" name="name" id="name" class="form-control input-sm"/>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <label for="name" class="control-label col-sm-12">会場名</label>
                      <div class="col-sm-12">
                        <input type="text" name="name" id="name" class="form-control input-sm"/>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-5">
                      <label for="continent" class="control-label col-sm-12">挙式日</label>
                      <div class="col-sm-12">
                        <input type="text" name="continent" id="continent" class="form-control input-sm"/>
                      </div>
                    </div>
                    <div class="col-sm-7">
                      <label for="continent" class="control-label col-sm-12">ご両家名</label>
                      <div class="col-sm-12">
                        <input type="text" name="continent" id="continent" class="form-control input-sm"/>
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <BButton variant="outline-secondary" type="reset" class="w-25">検索条件をクリア</BButton>
                    <BButton class="main-color text-light w-25 ms-3" @click="seartchClick">検索</BButton>
                  </div>
                </form>
              </BCardBody>
            </BCollapse>
          </BCard>
        </div>
      </div>
      <div id="search-list" class="row base-color mt-3">
        <div class="col-sm-12 row pt-3 pe-0">
          <div class="col-sm-6">
            検索結果<span class="h3 ms-1">46</span><span class="ms-1 me-2">件</span>1 - 10件を表示
          </div>
          <div class="col-sm-6 text-end pe-0">
            <BButton variant="primary">納品完了を登録</BButton>
          </div>
        </div>
        <div class="col-sm-12 mt-3">
          <BOverlay :show="overlayShow" rounded="sm">
            <table hover bordered>
              <b-thead>
                <tr>
                  <b-th v-for="(field, index) in fields" :key="index">{{field.label}}</b-th>
                </tr>
              </b-thead>
              <tbody>
                <template v-for="(item, index) in items" :key="index">
                  <tr>
                    <td v-for="(field, i) in fields" :key="i" :rowspan="(i === 0) ? 2 : 1" class="align-middle">{{item[field.key]}}</td>
                  </tr>
                  <tr class="hover-no-color">
                    <td :colspan="fields.length - 1">
                      <BButton variant="outline-primary" class="me-4"><b-icon icon="file-earmark-arrow-down"></b-icon>&nbsp;案件セット</BButton>
                      <BButton variant="outline-primary" class="me-4"><b-icon icon="file-earmark-arrow-down"></b-icon>&nbsp;納品セット</BButton>
                      <BButton class="me-4 carrot-color"><b-icon icon="check2-square"></b-icon>&nbsp;納品完了</BButton>
                      <BButton class=" carrot-color" @click="deliveryImagePageMove"><b-icon icon="file-earmark-image"></b-icon>&nbsp;納品画像</BButton>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </BOverlay>
        </div>
        <div class="col-sm-12 row pt-3 pe-0">
          <div class="col-sm-4">
            検索結果<span class="h3 ms-1">46</span><span class="ms-1 me-2">件</span>1 - 10件を表示
          </div>
          <div class="col-sm-4">
            <nav aria-label="Page navigation example">
              <ul class="pagination">
                <li class="page-item">
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <li class="page-item"><a class="page-link" href="#">1</a></li>
                <li class="page-item"><a class="page-link" href="#">2</a></li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item">
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-sm-4 text-end pe-0">
            <BButton variant="primary">納品完了を登録</BButton>
          </div>
        </div>
      </div>
    </div>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
export default {
  name: 'ProducePropositionList',
  components: { CommonLayout },
  data () {
    return {
      overlayShow: false,
      searchStatusLabels: [
        '制作依頼到着',
        '制作依頼受付済',
        '納品完了',
        '依頼到着見込',
        '制作依頼準備中',
        '全て'
      ],
      fields: [
        {
          key: 'project_no',
          label: '案件No.',
          sortable: false
        },
        {
          key: 'status',
          label: 'ステータス',
          sortable: false
        },
        {
          key: 'wedding_day',
          label: '挙式日',
          sortable: false
        },
        {
          key: 'facility',
          label: '施設',
          sortable: false
        },
        {
          key: 'venue',
          label: '会場',
          sortable: false
        },
        {
          key: 'reception_time',
          label: '披露宴時間',
          sortable: false
        },
        {
          key: 'number_of_people',
          label: '人数',
          sortable: false
        },
        {
          key: 'amount',
          label: '金額(税別)',
          sortable: false
        }
      ],
      items: [
        {project_no: '0100123', status: 'MacDonald', wedding_day: 40, facility: 40, venue: 40, reception_time: 40, number_of_people: 40, amount: 40},
        {project_no: '0100124', status: 'MacDonald', wedding_day: 40, facility: 40, venue: 40, reception_time: 40, number_of_people: 40, amount: 40},
        {project_no: '0100125', status: 'MacDonald', wedding_day: 40, facility: 40, venue: 40, reception_time: 40, number_of_people: 40, amount: 40},
        {project_no: '0100126', status: 'MacDonald', wedding_day: 40, facility: 40, venue: 40, reception_time: 40, number_of_people: 40, amount: 40}
      ]
    }
  },
  methods: {
    seartchClick () {
      this.overlayShow = true
      setTimeout(() => {
        this.overlayShow = false
      }, 4000)
    },
    deliveryImagePageMove () {
      this.$router.push('/trader/delivery_image')
    }
  }
}
</script>
<style>
table > thead > tr > th {
  background-color: #CACFEC !important;
  border-color: #CACFEC !important;
}
.table-hover tbody tr.hover-no-color:hover {
    color: unset;
    background-color: unset;
}
</style>
